import { hexToRgb } from './hexToRgb';

// Reference values of a perfect reflecting diffuser (Daylight, sRGB, Adobe-RGB)
const referenceValues = [95.047, 100, 108.883];
function hexToLab(color: string): number[] {
  // Standard-RGB → XYZ - https://www.easyrgb.com/en/math.php
  const [r, g, b] = hexToRgb(color).map((n) => {
    const normalizedN = n / 255;
    return (
      (normalizedN > 0.04045 ? Math.pow((normalizedN + 0.055) / 1.055, 2.4) : normalizedN / 12.92) *
      100
    );
  });

  const xyz = [
    r * 0.4124 + g * 0.3576 + b * 0.1805,
    r * 0.2126 + g * 0.7152 + b * 0.0722,
    r * 0.0193 + g * 0.1192 + b * 0.9505,
  ];

  // XYZ -> CIE-L*ab - https://www.easyrgb.com/en/math.php
  const [x, y, z] = xyz.map((n, i) => {
    const varN = n * referenceValues[i];
    return varN > 0.008856 ? Math.pow(varN, 1 / 3) : 7.787 * varN + 16 / 116;
  });

  return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
}

function squaredDelta(v1: number, v2: number) {
  return Math.pow(v1 - v2, 2);
}

export function compareColors(hexColor1: string, hexColor2: string) {
  if (hexColor1 === hexColor2) {
    return 0;
  }

  const lab1 = hexToLab(hexColor1);
  const lab2 = hexToLab(hexColor2);
  let sum = 0;

  sum += squaredDelta(lab1[0], lab2[0]);
  sum += squaredDelta(lab1[1], lab2[1]);
  sum += squaredDelta(lab1[2], lab2[2]);

  return Math.sqrt(sum);
}
